import { Injectable } from '@angular/core';
import { DataService } from './data.service';
//import * as FileSaver from 'file-saver';

@Injectable()
export class ReportsService {

    getEventRoute = '/api/user/';

    constructor(private dataService: DataService) {
    };

    getProjectTimelyReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/projecttimely', query, refresh);
    }

    getEmployeeTimelyReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/employeetimely', query, refresh);
    }

    getTimesheetReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/timesheetreport', query, refresh);
    }

    forgotpasswordUser(user: any) {
        return this.dataService.post('/api/user/forgetpassword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    changepasswordUser(user: any) {
        return this.dataService.post('/api/user/ChangePassword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    newpaswordUser(user: any) {
        return this.dataService.post('/api/user/newpasword', user).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    downloadFuelReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/report/fuelreport', query, refresh);
    }

    downloadReport(query: any) {
        return this.dataService.getExternalData(query);
    }

    downloadTripReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/report/tripreport', query, refresh);
    }
    downloadStoppageTruckReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/report/stoppagetruckreport', query, refresh);
    }
    viewTripSimulationReport(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/report/tripsimulation', query, refresh);
    }
    /*  downloadReport(body: any, refresh: boolean) {
         return this.dataService.getDataWithParams('/ovcbeneficiary/exportaspdf', body, refresh);
     } */
    tripsimulate(query: any, refresh: boolean) {
        return this.dataService.post('/api/triplog/tripsimulate', query).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    tripreport(data: any) {
        return this.dataService.post('/api/report', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    // Same /api/report endpoint tripreport() hits - ReportType (66 = LotteryReport)
    // in the request body is what actually picks the report server-side (see
    // ReportController.LoadReportByType / ReportRepository.GetReportDataAsync). This
    // is its own clearly-named call so lottery-report-popup.component.ts doesn't
    // have to call the misleadingly-named tripreport() directly.
    lotteryreport(data: any) {
        return this.dataService.post('/api/report', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    // Same /api/report endpoint tripreport()/lotteryreport() hit - ReportType (67 =
    // DBTDistrictWiseFlowProgressReport) in the request body is what picks this report
    // server-side (ReportController.LoadReportByType -> Rdlc/DBTDistrictWiseFlowProgressReport.rdlc,
    // data from ReportRepository.GetReportDataAsync -> sp_dbtdistrictwiseflowprogressreport).
    dbtDistrictWiseFlowProgressReport(data: any) {
        return this.dataService.post('/api/report', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    bookingidreport(data: any) {
        return this.dataService.post('/api/report/receipt', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }



    trackingInfo(query: any, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/triplog/trackinghistory/' + query.tripId + '/' + query.vehicleId, query, refresh);
    }

    saveFile = (blobContent: any, fileName: string, fileType: string) => {
        /*  if (fileName.endsWith(".xls")){
           fileName = fileName.replace(".xls", ".xlsx" )
         } */
        const byteCharacters = atob(blobContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        //FileSaver.saveAs(blob, fileName);
    }
    gpsinspectionreport(data) {
        return this.dataService.post('/api/report/gpsinspectionreport', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    serviceproviderList(refresh: boolean) {
        return this.dataService.getData('/api/lookup/allapplicationtypebyreport', refresh);
    }

    implementReportServiceProviderList(refresh: boolean) {
        return this.dataService.getData('/api/lookup/implementreportserviceprovidertype', refresh);
    }


}
